import Vue from 'vue'
import rpc from '../rpc.js'

function initialState() {
    return {
        images: {}
    }
}

export default {
    namespaced: true,
    state: initialState,
    mutations: {
        addImage(state, imageId) {
            Vue.set(state.images, imageId, true);
        },
        reset(state) {
            const s = initialState()
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        addToBasket({commit}, imageId) {
            commit("addImage", imageId)
        }
    }
}